import * as settings from "../../constants/settings";

import Statistics from "./Statistics";

export default class StatisticCorrection extends Statistics {
    /**
     * @param {Number}          id
     * @param {String}          colorName
     * @param {String}          colorCode
     * @param {String}          fandeckName
     * @param {String}          productName
     * @param {String}          baseName
     * @param {String}          packageName
     * @param {String}          bippPackageName
     * @param {Number}          dispensedPackageCount
     * @param {Number}          packageCount
     * @param {String}          customerName
     * @param {String}          colorRgb
     * @param {String}          timestampUtc
     * @param {Array}           customPackageName
     * @param {String}          moreInfo
     * @param {String}          moreInfoInternal
     * @param {Boolean}         hidden
     * @param {Number}          colorsStatsTypeId
     * @param {Boolean}         qualityControl
     * @param {String}          qualityControlDate
     * @param {Array | null}    colorants
     * @param {Array | null}    cumulativeColorants
     * @param {Array | null}    originalColorants
     * @param {String}          buildingSite
     * @param {Array | null}    colorantsByUnits
     * @param {Array | null}    cumulativeColorantsByUnits
     * @param {Array | null}    originalColorantsByUnits
     * @param {String | null}   clientName
     */
    constructor(
        id,
        colorName,
        colorCode,
        fandeckName,
        productName,
        baseName,
        packageName,
        bippPackageName,
        dispensedPackageCount,
        packageCount,
        customerName,
        colorRgb,
        timestampUtc,
        customPackageName,
        moreInfo,
        moreInfoInternal,
        hidden,
        colorsStatsTypeId,
        qualityControl,
        qualityControlDate,
        colorants,
        cumulativeColorants,
        originalColorants,
        operator,
        buildingSite,
        clientName,
        colorantsByUnits,
        cumulativeColorantsByUnits,
        originalColorantsByUnits,
        parentId
    ) {
        super(
            id,
            colorName,
            colorCode,
            fandeckName,
            productName,
            baseName,
            packageName,
            bippPackageName,
            dispensedPackageCount,
            packageCount,
            customerName,
            colorRgb,
            timestampUtc,
            customPackageName,
            moreInfo,
            moreInfoInternal,
            hidden,
            colorsStatsTypeId,
            qualityControl,
            qualityControlDate,
            colorants,
            cumulativeColorants,
            originalColorants,
            operator,
            buildingSite,
            clientName
        );

        this._colorantsByUnits = colorantsByUnits;
        this._cumulativeColorantsByUnits = cumulativeColorantsByUnits;
        this._originalColorantsByUnits = originalColorantsByUnits;
        this._parentId = parentId;
    }

    /**
     * Dispensed colorants.
     *
     * @param   string  unit
     * @returns Object | null
     */
    getColorantsByUnit = (unit) => {
        if (this._colorantsByUnits === null) {
            return null;
        }

        if (unit === settings.UNIT_G) {
            return this._colorantsByUnits.g;
        }

        if (unit === settings.UNIT_SHOT) {
            return this._colorantsByUnits.shots;
        }

        return this._colorantsByUnits.ml;
    };

    /**
     * Sum of all dispensed colorants.
     *
     * @param   string  unit
     * @returns Object | null
     */
    getCumulativeColorantsByUnit = (unit) => {
        if (this._cumulativeColorantsByUnits === null) {
            return this.getColorantsByUnit(unit);
        }

        if (unit === settings.UNIT_G) {
            return this._cumulativeColorantsByUnits.g;
        }

        if (unit === settings.UNIT_SHOT) {
            return this._cumulativeColorantsByUnits.shots;
        }

        return this._cumulativeColorantsByUnits.ml;
    };

    /**
     * Colorants from original formula.
     *
     * @param   string  unit
     * @returns Object | null
     */
    getOriginalColorantsByUnit = (unit) => {
        if (this._originalColorantsByUnits === null) {
            return this.getColorantsByUnit(unit);
        }

        if (unit === settings.UNIT_G) {
            return this._originalColorantsByUnits.g;
        }

        if (unit === settings.UNIT_SHOT) {
            return this._originalColorantsByUnits.shots;
        }

        return this._originalColorantsByUnits.ml;
    };

    /**
     * @return {Number}
     */
    get parentId() {
        return this._parentId;
    }
}
